import cx from "classnames";
import { Input } from "reactstrap";
import PropTypes from "prop-types";
import styles from "./TextField.module.scss";

const textAreaFields = ["description", "body"]; // add istextarea to props

export const TextField = ({
  name,
  value,
  placeholder,
  label,
  handleChange,
  validationError,
  className,
  handleBlur,
  isTextArea,
}) => {
  return (
    <div
      className={
        textAreaFields.includes(name) || isTextArea
          ? styles.textareaContainer
          : ""
      }
    >
      <p
        className={
          textAreaFields.includes(name) || isTextArea
            ? styles.fieldLabel
            : cx(styles.fieldLabel, {
                [styles.labelError]:
                  validationError && validationError.includes(name),
              })
        }
      >
        {label || placeholder || name[0].toUpperCase() + name.slice(1)}
      </p>
      <Input
        name={name}
        type={textAreaFields.includes(name) || isTextArea ? "textarea" : "text"}
        className={cx(
          className,
          textAreaFields.includes(name) || isTextArea
            ? styles.textarea
            : styles.input,
          {
            [styles.inputError]:
              validationError && validationError.includes(name),
          }
        )}
        placeholder={
          placeholder ||
          (textAreaFields.includes(name)
            ? ""
            : name[0].toUpperCase() + name.slice(1))
        }
        onChange={handleChange}
        value={value}
        onBlur={handleBlur}
      />
      {validationError && validationError.includes(name) && (
        <p
          className={cx(styles.errorLabel, {
            "d-block": validationError && validationError.includes(name),
          })}
        >
          Please, write {placeholder || name}
        </p>
      )}
    </div>
  );
};

TextField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  validationError: PropTypes.array,
};
TextField.dafaultProps = {
  name: "",
  value: "",
  placeholder: "",
  handleChange: () => {},
  validationError: [],
};
